// extracted by mini-css-extract-plugin
export default {"addToCartControl":"QY-z","giftCard":"RY-z","btnContainer":"SY-z","cartButton":"TY-z","disabled":"UY-z"};